import React from 'react';
import Layout from '../layout/Layout';
import FolderList from '../components/FolderList';

export default function Home() {
  return (
    <Layout>
        <FolderList />
    </Layout>
  )
}
